import apiClient from 'hub-http/clients/apiClient';
export const API_BASE = `forms/v2/forms`;
export const fetchFormsByIds = guids => {
  return apiClient.get(`${API_BASE}/batch`, {
    query: {
      guid: guids
    }
  });
};